var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',[_c('el-row',{attrs:{"gutter":_vm.model.gutter}},[_c('div',{staticClass:"drag-wrapper"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }